/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { DataTableRenderProps, PagedTable, PagedTableProps } from 'bold-ui'
import { AccordionDataTable } from 'components/accordion/accordion-data-table/AccordionDataTable'
import { TableBox } from 'components/table'
import { VisualizarPaginaButton } from 'components/VisualizarPaginaButton'
import { AcompanhamentoCondicaoSaudeTematicaEnum } from 'graphql/types.generated'
import { useServerTime } from 'hooks/useServerTime'

import { BuscaCidadaoQueryResultModel } from '../../model/lista-tematica/model-acompanhamentoCondicaoSaudeListaTematica'
import { AcompanhamentoCondicaoSaudeAccordionPanel } from '../accordion/AcompanhamentoCondicaoSaudeAccordionPanel'
import { renderInformacao, renderUltimasMedicoes, renderUltimoAtend } from './render-acompanhamentoCondicaoSaudeColumns'

interface AcompanhamentoCondicaoSaudeTableSelectorProps
  extends Omit<PagedTableProps<BuscaCidadaoQueryResultModel>, 'columns'> {
  hasIvcfFilter?: boolean
  tematica: AcompanhamentoCondicaoSaudeTematicaEnum
}

export const AcompanhamentoCondicaoSaudeTable = (props: AcompanhamentoCondicaoSaudeTableSelectorProps) => {
  const { tematica, ...tableProps } = props
  const { getServerTimeNow } = useServerTime()

  return (
    <TableBox>
      <PagedTable<BuscaCidadaoQueryResultModel>
        {...tableProps}
        render={(renderProps: DataTableRenderProps) => (
          <AccordionDataTable
            {...renderProps}
            components={{ AccordionPanel: ({ row }) => AcompanhamentoCondicaoSaudeAccordionPanel({ row, tematica }) }}
          />
        )}
        columns={[
          {
            name: 'cidadao',
            header: 'Identificação',
            sortable: true,
            render: (row) => renderInformacao(row),
            style: css`
              width: 20rem;
            `,
          },
          {
            name: 'ultimosAtendimentos',
            header: 'Últimos atendimentos',
            sortable: false,
            render: (row) => renderUltimoAtend(row, getServerTimeNow),
            style: css`
              width: 20rem;
              padding: 1rem;
            `,
          },
          {
            name: 'ultimasMedicoes',
            header: 'Últimas medições',
            sortable: false,
            render: renderUltimasMedicoes,
            style: css`
              width: 25rem;
            `,
          },
          {
            name: 'visualizarCadastro',
            header: '',
            render: (row: BuscaCidadaoQueryResultModel) => (
              <VisualizarPaginaButton
                path={`/cidadao/${row.idCidadao}/informacoes`}
                tooltipText='Visualizar cadastro'
              />
            ),
            style: css`
              width: 60px;
              margin-left: -60px;
            `,
          },
        ]}
      />
    </TableBox>
  )
}
